var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "team-region-member-controls-container" }, [
    _vm.showTeamRegion && _vm.teamRegions && _vm.teamRegions.length > 0
      ? _c(
          "div",
          [
            _c(
              "form-group",
              { attrs: { name: "teamRegion", label: "Team Region" } },
              [
                _c("team-region-options", {
                  attrs: {
                    selected: _vm.selectedValues.teamRegionId,
                    mode: _vm.mode,
                  },
                  on: { selectedOption: _vm.handleTeamRegionChanged },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    !_vm.isSingleUser && _vm.showTeamMembers
      ? _c(
          "div",
          [
            _c(
              "form-group",
              {
                staticClass: "team-member",
                attrs: { name: "member", label: "Team Member" },
              },
              [
                _c("vue-select", {
                  attrs: {
                    "data-testid": "member-carrier-id",
                    reduce: function (item) {
                      return item.memberOrCarrierId
                    },
                    label: "fullName",
                    options: _vm.filteredTeamMemberOptions,
                    searchable: _vm.$root.isDesktop,
                    selectable: function (option) {
                      return option.selectable
                    },
                    filter: _vm.memberFilter,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _vm.displayAvailabilityIndicator
                              ? _c(
                                  "div",
                                  { staticClass: "member-options" },
                                  [
                                    (option.fullName || "") === "Unassigned"
                                      ? _c("div", {
                                          staticClass: "status-indicator empty",
                                        })
                                      : option.fullName
                                      ? _c("availability-indicator", {
                                          attrs: {
                                            "is-available":
                                              option.isAvailableBasedOnRosterConfiguration,
                                          },
                                        })
                                      : _vm._e(),
                                    option.selectable && option.fullName
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(option.fullName) +
                                              "\n                            "
                                          ),
                                          option.memberCode
                                            ? _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "feature",
                                                      rawName: "v-feature",
                                                      value:
                                                        _vm.FEATURE_NAMES
                                                          .MemberCodeDisplay,
                                                      expression:
                                                        "FEATURE_NAMES.MemberCodeDisplay",
                                                    },
                                                  ],
                                                  staticClass: "member-code",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                (" +
                                                      _vm._s(
                                                        option.memberCode
                                                      ) +
                                                      ")\n                            "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ])
                                      : _c("hr"),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  option.selectable && option.fullName
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(option.fullName) +
                                            "\n                            "
                                        ),
                                        option.memberCode
                                          ? _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "feature",
                                                    rawName: "v-feature",
                                                    value:
                                                      _vm.FEATURE_NAMES
                                                        .MemberCodeDisplay,
                                                    expression:
                                                      "FEATURE_NAMES.MemberCodeDisplay",
                                                  },
                                                ],
                                                staticClass: "member-code",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                (" +
                                                    _vm._s(option.memberCode) +
                                                    ")\n                            "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ])
                                    : _c("hr"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "selected-option",
                        fn: function (option) {
                          return [
                            _vm.displayAvailabilityIndicator &&
                            ((option && option.fullName) ||
                              _vm.memberOrCarrierName)
                              ? _c(
                                  "div",
                                  { staticClass: "member-options" },
                                  [
                                    ((option && option.fullName) ||
                                      _vm.memberOrCarrierName) === "Unassigned"
                                      ? _c("div", {
                                          staticClass: "status-indicator empty",
                                        })
                                      : option && option.fullName
                                      ? _c("availability-indicator", {
                                          attrs: {
                                            "is-available":
                                              option.isAvailableBasedOnRosterConfiguration,
                                          },
                                        })
                                      : _vm._e(),
                                    _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            (option && option.fullName) ||
                                              _vm.memberOrCarrierName
                                          ) +
                                          "\n                            "
                                      ),
                                      option && option.memberCode
                                        ? _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "feature",
                                                  rawName: "v-feature",
                                                  value:
                                                    _vm.FEATURE_NAMES
                                                      .MemberCodeDisplay,
                                                  expression:
                                                    "FEATURE_NAMES.MemberCodeDisplay",
                                                },
                                              ],
                                              staticClass: "member-code",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                (" +
                                                  _vm._s(option.memberCode) +
                                                  ")\n                            "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          (option && option.fullName) ||
                                            _vm.memberOrCarrierName
                                        ) +
                                        "\n                            "
                                    ),
                                    option && option.memberCode
                                      ? _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "feature",
                                                rawName: "v-feature",
                                                value:
                                                  _vm.FEATURE_NAMES
                                                    .MemberCodeDisplay,
                                                expression:
                                                  "FEATURE_NAMES.MemberCodeDisplay",
                                              },
                                            ],
                                            staticClass: "member-code",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                (" +
                                                _vm._s(option.memberCode) +
                                                ")\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4253476886
                  ),
                  model: {
                    value: _vm.selectedValues.memberOrCarrierId,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectedValues, "memberOrCarrierId", $$v)
                    },
                    expression: "selectedValues.memberOrCarrierId",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }